// // import React, { useState } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { MdEmail, MdArrowBack } from 'react-icons/md';
// // import styles from './Login.module.css';
// // import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
// // // import ConfirmationModal from '../components/ConfirmationModal/ConfirmationModal';


// // const Login = () => {
// //     const navigate = useNavigate();
// //     const [step, setStep] = useState(1);
// //     const [email, setEmail] = useState('');
// //     const [otp, setOtp] = useState(['', '', '', '', '', '']);
// //     const [loading, setLoading] = useState(false);
// //     const [error, setError] = useState('');
// //     const [resendTimer, setResendTimer] = useState(0);

// //     const [confirmModal, setConfirmModal] = useState({
// //         show: false,
// //         title: '',
// //         message: '',
// //         type: 'info',
// //         onConfirm: null
// //     });

// //     const handleSendOTP = async (e) => {
// //         e.preventDefault();
// //         setError('');
// //         setLoading(true);

// //         try {
// //             const response = await fetch('http://localhost:5000/api/auth/send-otp', {
// //                 method: 'POST',
// //                 headers: { 'Content-Type': 'application/json' },
// //                 body: JSON.stringify({ email_address: email })
// //             });

// //             const data = await response.json();
// //             console.log(data);
// //             if (response.ok && data.success) {
// //                 setStep(2);
// //                 startResendTimer();
// //                 setConfirmModal({
// //                     show: true,
// //                     title: 'OTP Sent!',
// //                     message: 'Verification code has been sent to your email address. Please check your inbox.',
// //                     type: 'success',
// //                     onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
// //                 });
// //             } else {
// //                 setError(data.message || 'Failed to send OTP. Please try again.');
// //             }
// //         } catch (err) {
// //             setError('Network error. Please check if backend is running on port 5000.');
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     const handleOtpChange = (index, value) => {
// //         if (value && !/^\d$/.test(value)) return;
// //         const newOtp = [...otp];
// //         newOtp[index] = value;
// //         setOtp(newOtp);
// //         if (value && index < 5) {
// //             document.getElementById(`otp-${index + 1}`)?.focus();
// //         }
// //     };

// //     const handleOtpKeyDown = (index, e) => {
// //         if (e.key === 'Backspace' && !otp[index] && index > 0) {
// //             document.getElementById(`otp-${index - 1}`)?.focus();
// //         }
// //     };

// //     const handleOtpPaste = (e) => {
// //         e.preventDefault();
// //         const pastedData = e.clipboardData.getData('text').slice(0, 6);
// //         if (!/^\d+$/.test(pastedData)) return;
// //         const newOtp = pastedData.split('').concat(Array(6).fill('')).slice(0, 6);
// //         setOtp(newOtp);
// //         const lastIndex = Math.min(pastedData.length, 5);
// //         document.getElementById(`otp-${lastIndex}`)?.focus();
// //     };

// //     // const handleVerifyOTP = async (e) => {
// //     //     e.preventDefault();
// //     //     const otpCode = otp.join('');

// //     //     if (otpCode.length !== 6) {
// //     //         setError('Please enter complete 6-digit code');
// //     //         return;
// //     //     }

// //     //     setError('');
// //     //     setLoading(true);

// //     //     try {
// //     //         const response = await fetch('http://localhost:5000/api/auth/verify-otp', {
// //     //             method: 'POST',
// //     //             headers: { 'Content-Type': 'application/json' },
// //     //             body: JSON.stringify({ email_address: email, otp: otpCode })
// //     //         });

// //     //         const data = await response.json();

// //     //         if (response.ok && data.success) {
// //     //             localStorage.setItem('token', data.token);
// //     //             localStorage.setItem('user', JSON.stringify(data.user));

// //     //             setConfirmModal({
// //     //                 show: true,
// //     //                 title: 'Login Successful!',
// //     //                 message: 'Welcome back! Redirecting to dashboard...',
// //     //                 type: 'success',
// //     //                 onConfirm: () => {
// //     //                     setConfirmModal({ ...confirmModal, show: false });
// //     //                     navigate('/', { replace: true });
// //     //                 }
// //     //             });
// //     //         } else {
// //     //             setError(data.message || 'Invalid verification code. Please try again.');
// //     //             setOtp(['', '', '', '', '', '']);
// //     //             document.getElementById('otp-0')?.focus();
// //     //         }
// //     //     } catch (err) {
// //     //         setError('Network error. Please try again.');
// //     //         setOtp(['', '', '', '', '', '']);
// //     //         document.getElementById('otp-0')?.focus();
// //     //     } finally {
// //     //         setLoading(false);
// //     //     }
// //     // };

// //     const handleVerifyOTP = async (e) => {
// //         e.preventDefault();
// //         const otpCode = otp.join('');

// //         if (otpCode.length !== 6) {
// //             setError('Please enter complete 6-digit code');
// //             return;
// //         }

// //         setError('');
// //         setLoading(true);

// //         try {
// //             const response = await fetch('http://localhost:5000/api/auth/verify-otp', {
// //                 method: 'POST',
// //                 headers: { 'Content-Type': 'application/json' },
// //                 body: JSON.stringify({ email_address: email, otp: otpCode })
// //             });

// //             const data = await response.json();

// //             if (response.ok && data.success) {
// //                 localStorage.setItem('token', data.token);
// //                 localStorage.setItem('user', JSON.stringify(data.user));
// //                 navigate('/', { replace: true });
// //             } else {
// //                 setError(data.message || 'Invalid verification code. Please try again.');
// //                 setOtp(['', '', '', '', '', '']);
// //                 document.getElementById('otp-0')?.focus();
// //             }
// //         } catch (err) {
// //             setError('Network error. Please try again.');
// //             setOtp(['', '', '', '', '', '']);
// //             document.getElementById('otp-0')?.focus();
// //         } finally {
// //             setLoading(false);
// //         }
// //     };
// //     const handleResendOTP = async () => {
// //         if (resendTimer > 0) return;

// //         setError('');
// //         setLoading(true);

// //         try {
// //             const response = await fetch('http://localhost:5000/api/auth/resend-otp', {
// //                 method: 'POST',
// //                 headers: { 'Content-Type': 'application/json' },
// //                 body: JSON.stringify({ email_address: email })
// //             });

// //             const data = await response.json();

// //             if (response.ok && data.success) {
// //                 setOtp(['', '', '', '', '', '']);
// //                 document.getElementById('otp-0')?.focus();
// //                 startResendTimer();
// //                 setConfirmModal({
// //                     show: true,
// //                     title: 'OTP Resent!',
// //                     message: 'A new verification code has been sent to your email.',
// //                     type: 'success',
// //                     onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
// //                 });
// //             } else {
// //                 setError(data.message || 'Failed to resend OTP. Please try again.');
// //             }
// //         } catch (err) {
// //             setError('Network error. Please try again.');
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     const startResendTimer = () => {
// //         setResendTimer(60);
// //         const interval = setInterval(() => {
// //             setResendTimer(prev => {
// //                 if (prev <= 1) {
// //                     clearInterval(interval);
// //                     return 0;
// //                 }
// //                 return prev - 1;
// //             });
// //         }, 1000);
// //     };

// //     const handleBackToEmail = () => {
// //         setStep(1);
// //         setOtp(['', '', '', '', '', '']);
// //         setError('');
// //     };

// //     return (
// //         <div className={styles.loginPage}>
// //             <div className={styles.loginContainer}>
// //                 <div className={styles.loginCard}>
// //                     <div className={styles.logoSection}>
// //                         <div className={styles.logo}>SclinEDC</div>
// //                         <h1 className={styles.title}>Hypertension Management Study</h1>
// //                         <p className={styles.subtitle}>Version: 1.0</p>
// //                     </div>

// //                     {step === 1 ? (
// //                         <>
// //                             <h2 className={styles.formTitle}>Sign In</h2>
// //                             <p className={styles.formSubtitle}>Enter your email address to receive verification code</p>

// //                             <form onSubmit={handleSendOTP} className={styles.form}>
// //                                 <div className={styles.inputGroup}>
// //                                     <label>Email Address</label>
// //                                     <div className={styles.inputWrapper}>
// //                                         <MdEmail className={styles.inputIcon} />
// //                                         <input
// //                                             type="email"
// //                                             placeholder="Enter your email"
// //                                             value={email}
// //                                             onChange={(e) => setEmail(e.target.value)}
// //                                             required
// //                                             disabled={loading}
// //                                             autoFocus
// //                                         />
// //                                     </div>
// //                                 </div>

// //                                 {error && <div className={styles.error}>{error}</div>}

// //                                 <button type="submit" className={styles.submitBtn} disabled={loading}>
// //                                     {loading ? 'Sending...' : 'Send Verification Code'}
// //                                 </button>
// //                             </form>
// //                         </>
// //                     ) : (
// //                         <>
// //                             <button className={styles.backButton} onClick={handleBackToEmail} disabled={loading}>
// //                                 <MdArrowBack /> Back
// //                             </button>

// //                             <h2 className={styles.formTitle}>Verify Email</h2>
// //                             <p className={styles.formSubtitle}>
// //                                 Enter the 6-digit code sent to<br />
// //                                 <strong>{email}</strong>
// //                             </p>

// //                             <form onSubmit={handleVerifyOTP} className={styles.form}>
// //                                 <div className={styles.otpContainer}>
// //                                     {otp.map((digit, index) => (
// //                                         <input
// //                                             key={index}
// //                                             id={`otp-${index}`}
// //                                             type="text"
// //                                             maxLength="1"
// //                                             className={styles.otpInput}
// //                                             value={digit}
// //                                             onChange={(e) => handleOtpChange(index, e.target.value)}
// //                                             onKeyDown={(e) => handleOtpKeyDown(index, e)}
// //                                             onPaste={index === 0 ? handleOtpPaste : undefined}
// //                                             autoFocus={index === 0}
// //                                             disabled={loading}
// //                                         />
// //                                     ))}
// //                                 </div>

// //                                 {error && <div className={styles.error}>{error}</div>}

// //                                 <button
// //                                     type="submit"
// //                                     className={styles.submitBtn}
// //                                     disabled={loading || otp.join('').length !== 6}
// //                                 >
// //                                     {loading ? 'Verifying...' : 'Verify & Sign In'}
// //                                 </button>

// //                                 <div className={styles.resendSection}>
// //                                     {resendTimer > 0 ? (
// //                                         <p className={styles.resendTimer}>Resend code in {resendTimer}s</p>
// //                                     ) : (
// //                                         <p className={styles.resendText}>
// //                                             Didn't receive code?
// //                                             <button
// //                                                 type="button"
// //                                                 onClick={handleResendOTP}
// //                                                 className={styles.resendBtn}
// //                                                 disabled={loading}
// //                                             >
// //                                                 Resend
// //                                             </button>
// //                                         </p>
// //                                     )}
// //                                 </div>
// //                             </form>
// //                         </>
// //                     )}
// //                 </div>
// //             </div>

// //             <ConfirmationModal
// //                 show={confirmModal.show}
// //                 title={confirmModal.title}
// //                 message={confirmModal.message}
// //                 type={confirmModal.type}
// //                 onConfirm={confirmModal.onConfirm}
// //             // onCancel={() => setConfirmModal({ ...confirmModal, show: false })}
// //             />
// //         </div>
// //     );
// // };

// // export default Login;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { MdEmail, MdArrowBack, MdLock } from 'react-icons/md';
// import { FaGoogle, FaMicrosoft, FaApple } from 'react-icons/fa';
// import logo from '../../../Assets/image.png'
// import styles from './Login.module.css';
// import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';

// const Login = () => {
//     const navigate = useNavigate();
//     const [step, setStep] = useState(1);
//     const [email, setEmail] = useState('');
//     const [otp, setOtp] = useState(['', '', '', '', '', '']);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [resendTimer, setResendTimer] = useState(0);
//     const [rememberMe, setRememberMe] = useState(false);

//     const [confirmModal, setConfirmModal] = useState({
//         show: false,
//         title: '',
//         message: '',
//         type: 'info',
//         onConfirm: null
//     });

//     const handleSendOTP = async (e) => {
//         e.preventDefault();
//         setError('');
//         setLoading(true);

//         try {
//             const response = await fetch('http://localhost:5000/api/auth/send-otp', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ email_address: email })
//             });

//             const data = await response.json();
//             console.log(data);
//             if (response.ok && data.success) {
//                 setStep(2);
//                 startResendTimer();
//                 setConfirmModal({
//                     show: true,
//                     title: 'OTP Sent!',
//                     message: 'Verification code has been sent to your email address. Please check your inbox.',
//                     type: 'success',
//                     onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
//                 });
//             } else {
//                 setError(data.message || 'Failed to send OTP. Please try again.');
//             }
//         } catch (err) {
//             setError('Network error. Please check if backend is running on port 5000.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleOtpChange = (index, value) => {
//         if (value && !/^\d$/.test(value)) return;
//         const newOtp = [...otp];
//         newOtp[index] = value;
//         setOtp(newOtp);
//         if (value && index < 5) {
//             document.getElementById(`otp-${index + 1}`)?.focus();
//         }
//     };

//     const handleOtpKeyDown = (index, e) => {
//         if (e.key === 'Backspace' && !otp[index] && index > 0) {
//             document.getElementById(`otp-${index - 1}`)?.focus();
//         }
//     };

//     const handleOtpPaste = (e) => {
//         e.preventDefault();
//         const pastedData = e.clipboardData.getData('text').slice(0, 6);
//         if (!/^\d+$/.test(pastedData)) return;
//         const newOtp = pastedData.split('').concat(Array(6).fill('')).slice(0, 6);
//         setOtp(newOtp);
//         const lastIndex = Math.min(pastedData.length, 5);
//         document.getElementById(`otp-${lastIndex}`)?.focus();
//     };

//     const handleVerifyOTP = async (e) => {
//         e.preventDefault();
//         const otpCode = otp.join('');

//         if (otpCode.length !== 6) {
//             setError('Please enter complete 6-digit code');
//             return;
//         }

//         setError('');
//         setLoading(true);

//         try {
//             const response = await fetch('http://localhost:5000/api/auth/verify-otp', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ email_address: email, otp: otpCode })
//             });

//             const data = await response.json();

//             if (response.ok && data.success) {
//                 localStorage.setItem('token', data.token);
//                 localStorage.setItem('user', JSON.stringify(data.user));
//                 navigate('/', { replace: true });
//             } else {
//                 setError(data.message || 'Invalid verification code. Please try again.');
//                 setOtp(['', '', '', '', '', '']);
//                 document.getElementById('otp-0')?.focus();
//             }
//         } catch (err) {
//             setError('Network error. Please try again.');
//             setOtp(['', '', '', '', '', '']);
//             document.getElementById('otp-0')?.focus();
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleResendOTP = async () => {
//         if (resendTimer > 0) return;

//         setError('');
//         setLoading(true);

//         try {
//             const response = await fetch('http://localhost:5000/api/auth/resend-otp', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ email_address: email })
//             });

//             const data = await response.json();

//             if (response.ok && data.success) {
//                 setOtp(['', '', '', '', '', '']);
//                 document.getElementById('otp-0')?.focus();
//                 startResendTimer();
//                 setConfirmModal({
//                     show: true,
//                     title: 'OTP Resent!',
//                     message: 'A new verification code has been sent to your email.',
//                     type: 'success',
//                     onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
//                 });
//             } else {
//                 setError(data.message || 'Failed to resend OTP. Please try again.');
//             }
//         } catch (err) {
//             setError('Network error. Please try again.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const startResendTimer = () => {
//         setResendTimer(60);
//         const interval = setInterval(() => {
//             setResendTimer(prev => {
//                 if (prev <= 1) {
//                     clearInterval(interval);
//                     return 0;
//                 }
//                 return prev - 1;
//             });
//         }, 1000);
//     };

//     const handleBackToEmail = () => {
//         setStep(1);
//         setOtp(['', '', '', '', '', '']);
//         setError('');
//     };

//     return (
//         <div className={styles.loginPage}>
//             {/* Left Side - Welcome Content */}
//             <div className={styles.leftSide}>
//                 <div className={styles.brandingSection}>
//                     {/* <div className={styles.logoWrapper}>
//                         <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
//                             <rect width="40" height="40" rx="8" fill="url(#loginGradient)" />
//                             <path d="M20 10L12 15L20 20L28 15L20 10Z" fill="white" opacity="0.9" />
//                             <path d="M12 25L20 30L28 25V20L20 25L12 20V25Z" fill="white" opacity="0.7" />
//                             <defs>
//                                 <linearGradient id="loginGradient" x1="0" y1="0" x2="40" y2="40">
//                                     <stop offset="0%" stopColor="#3B82F6" />
//                                     <stop offset="100%" stopColor="#8B5CF6" />
//                                 </linearGradient>
//                             </defs>
//                         </svg>
//                     </div> */}

//                     <h1 className={styles.welcomeTitle}>
//                         Welcome to the <span className={styles.brandName}>SclinEDC</span> Community
//                     </h1>

//                     <p className={styles.welcomeDescription}>
//                         SclinEDC empowers clinical teams to design, manage, and monitor electronic data capture workflows with precision and compliance. Join us to simplify study setup, streamline data collection, and accelerate clinical research outcomes.
//                     </p>

//                     <div className={styles.statsSection}>
//                         <div className={styles.statItem}>
//                             <div className={styles.statNumber}>17,000+</div>
//                             <div className={styles.statLabel}>Professionals</div>
//                         </div>
//                         <div className={styles.statItem}>
//                             <div className={styles.statNumber}>500+</div>
//                             <div className={styles.statLabel}>Studies</div>
//                         </div>
//                         <div className={styles.statItem}>
//                             <div className={styles.statNumber}>50+</div>
//                             <div className={styles.statLabel}>Countries</div>
//                         </div>
//                     </div>

//                     <div className={styles.trustBadge}>
//                         <p className={styles.trustText}>
//                             More than 17,000 professionals trust <strong>SclinEDC</strong> — now it's your turn.
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             {/* Right Side - Login Form with Background Image */}
//             <div className={styles.rightSide}>


//                 {/* Login Form Card */}
//                 <div className={styles.loginCard}>
//                     {/* <div className={styles.cardHeader}>
//                         <h3 className={styles.cardTitle}>Sign in</h3>
//                         <p className={styles.cardSubtitle}>Don't have an account? <a href="/signup" className={styles.signupLink}>Sign up</a></p>
//                     </div> */}
//                     <div className={styles.cardHeader}>
//                         <img src={logo} alt="SclinEDC Logo" className={styles.logoImage} />
//                         <h3 className={styles.cardTitle}>Sign in</h3>
//                         <p className={styles.cardSubtitle}>
//                             Don't have an account? <a href="/signup" className={styles.signupLink}>Sign up</a>
//                         </p>
//                     </div>
//                     {step === 1 ? (
//                         <form onSubmit={handleSendOTP} className={styles.form}>
//                             <div className={styles.inputGroup}>
//                                 <label className={styles.inputLabel}>Email address</label>
//                                 <div className={styles.inputWrapper}>
//                                     <MdEmail className={styles.inputIcon} />
//                                     <input
//                                         type="email"
//                                         placeholder="name@company.com"
//                                         value={email}
//                                         onChange={(e) => setEmail(e.target.value)}
//                                         className={styles.input}
//                                         required
//                                         disabled={loading}
//                                         autoFocus
//                                     />
//                                 </div>
//                             </div>

//                             <div className={styles.formOptions}>
//                                 <label className={styles.checkboxLabel}>
//                                     <input
//                                         type="checkbox"
//                                         checked={rememberMe}
//                                         onChange={(e) => setRememberMe(e.target.checked)}
//                                         className={styles.checkbox}
//                                     />
//                                     <span>Remember me</span>
//                                 </label>
//                                 <a href="/forgot-password" className={styles.forgotLink}>Forgot password?</a>
//                             </div>

//                             {error && (
//                                 <div className={styles.errorAlert}>
//                                     <span className={styles.errorIcon}>⚠</span>
//                                     <span>{error}</span>
//                                 </div>
//                             )}

//                             <button type="submit" className={styles.submitBtn} disabled={loading}>
//                                 {loading ? (
//                                     <>
//                                         <span className={styles.spinner}></span>
//                                         Sending...
//                                     </>
//                                 ) : (
//                                     'Sign in'
//                                 )}
//                             </button>

//                             {/* <div className={styles.divider}>
//                                 <span>Or continue with</span>
//                             </div>

//                             <div className={styles.socialButtons}>
//                                 <button type="button" className={styles.socialBtn} disabled>
//                                     <FaGoogle />
//                                 </button>
//                                 <button type="button" className={styles.socialBtn} disabled>
//                                     <FaMicrosoft />
//                                 </button>
//                                 <button type="button" className={styles.socialBtn} disabled>
//                                     <FaApple />
//                                 </button>
//                             </div> */}
//                         </form>
//                     ) : (
//                         <form onSubmit={handleVerifyOTP} className={styles.form}>
//                             <button
//                                 type="button"
//                                 className={styles.backButton}
//                                 onClick={handleBackToEmail}
//                                 disabled={loading}
//                             >
//                                 <MdArrowBack /> Back to email
//                             </button>

//                             <div className={styles.otpHeader}>
//                                 <h4 className={styles.otpTitle}>Verify your email</h4>
//                                 <p className={styles.otpSubtitle}>
//                                     Enter the 6-digit code sent to<br />
//                                     <strong>{email}</strong>
//                                 </p>
//                             </div>

//                             <div className={styles.otpContainer}>
//                                 {otp.map((digit, index) => (
//                                     <input
//                                         key={index}
//                                         id={`otp-${index}`}
//                                         type="text"
//                                         maxLength="1"
//                                         className={styles.otpInput}
//                                         value={digit}
//                                         onChange={(e) => handleOtpChange(index, e.target.value)}
//                                         onKeyDown={(e) => handleOtpKeyDown(index, e)}
//                                         onPaste={index === 0 ? handleOtpPaste : undefined}
//                                         autoFocus={index === 0}
//                                         disabled={loading}
//                                     />
//                                 ))}
//                             </div>

//                             {error && (
//                                 <div className={styles.errorAlert}>
//                                     <span className={styles.errorIcon}>⚠</span>
//                                     <span>{error}</span>
//                                 </div>
//                             )}

//                             <button
//                                 type="submit"
//                                 className={styles.submitBtn}
//                                 disabled={loading || otp.join('').length !== 6}
//                             >
//                                 {loading ? (
//                                     <>
//                                         <span className={styles.spinner}></span>
//                                         Verifying...
//                                     </>
//                                 ) : (
//                                     'Verify & Sign In'
//                                 )}
//                             </button>

//                             <div className={styles.resendSection}>
//                                 {resendTimer > 0 ? (
//                                     <p className={styles.resendTimer}>
//                                         Resend code in <strong>{resendTimer}s</strong>
//                                     </p>
//                                 ) : (
//                                     <p className={styles.resendText}>
//                                         Didn't receive the code?{' '}
//                                         <button
//                                             type="button"
//                                             onClick={handleResendOTP}
//                                             className={styles.resendBtn}
//                                             disabled={loading}
//                                         >
//                                             Resend
//                                         </button>
//                                     </p>
//                                 )}
//                             </div>
//                         </form>
//                     )}
//                 </div>
//             </div>

//             <ConfirmationModal
//                 show={confirmModal.show}
//                 title={confirmModal.title}
//                 message={confirmModal.message}
//                 type={confirmModal.type}
//                 onConfirm={confirmModal.onConfirm}
//             />
//         </div>
//     );
// };

// export default Login;

import React, { useState } from 'react';
import WelcomeSection from './WelcomeSection';
import LoginCard from './LoginCard';
import EmailStep from './EmailStep';
// import OTPStep from './OTPStep';
import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
// import { useAuth } from '../../../hooks/useAuth';
// import { useResendTimer } from '../../../hooks/useResendTimer';
import styles from './Login.module.css';
// import OTPStep from './OtpStep';
import { useAuth } from './UseAuth';
import { useResendTimer } from './UseResend';
import OTPStep from './OtpStep';

const Login = () => {
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [rememberMe, setRememberMe] = useState(false);

    const { loading, error, setError, handleSendOTP, handleVerifyOTP, handleResendOTP } = useAuth();
    const { resendTimer, startResendTimer, resetTimer } = useResendTimer();

    const [confirmModal, setConfirmModal] = useState({
        show: false,
        title: '',
        message: '',
        type: 'info',
        onConfirm: null
    });

    const showModal = (title, message, type = 'success') => {
        setConfirmModal({
            show: true,
            title,
            message,
            type,
            onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
        });
    };

    const onSendOTP = async (e) => {
        e.preventDefault();
        const result = await handleSendOTP(email);

        if (result.success) {
            setStep(2);
            startResendTimer();
            showModal(
                'OTP Sent!',
                'Verification code has been sent to your email address. Please check your inbox.'
            );
        }
    };

    const onVerifyOTP = async (e) => {
        e.preventDefault();
        const otpCode = otp.join('');
        const result = await handleVerifyOTP(email, otpCode);

        if (!result.success) {
            setOtp(['', '', '', '', '', '']);
            document.getElementById('otp-0')?.focus();
        }
    };

    const onResendOTP = async () => {
        if (resendTimer > 0) return;

        const result = await handleResendOTP(email);

        if (result.success) {
            setOtp(['', '', '', '', '', '']);
            document.getElementById('otp-0')?.focus();
            startResendTimer();
            showModal(
                'OTP Resent!',
                'A new verification code has been sent to your email.'
            );
        }
    };

    const handleBackToEmail = () => {
        setStep(1);
        setOtp(['', '', '', '', '', '']);
        setError('');
        resetTimer();
    };

    return (
        <div className={styles.loginPage}>
            <WelcomeSection />

            <div className={styles.rightSide}>
                <LoginCard>
                    {step === 1 ? (
                        <EmailStep
                            email={email}
                            setEmail={setEmail}
                            rememberMe={rememberMe}
                            setRememberMe={setRememberMe}
                            onSubmit={onSendOTP}
                            loading={loading}
                            error={error}
                        />
                    ) : (
                        <OTPStep
                            email={email}
                            otp={otp}
                            setOtp={setOtp}
                            onSubmit={onVerifyOTP}
                            onBack={handleBackToEmail}
                            onResend={onResendOTP}
                            loading={loading}
                            error={error}
                            resendTimer={resendTimer}
                        />
                    )}
                </LoginCard>
            </div>

            <ConfirmationModal
                show={confirmModal.show}
                title={confirmModal.title}
                message={confirmModal.message}
                type={confirmModal.type}
                onConfirm={confirmModal.onConfirm}
            />
        </div>
    );
};

export default Login;